import React from "react";
import { motion } from "framer-motion";
import { WordMark } from "./Logo";
import LangToggle from "./LangToggle";
import { useI18n } from "@/i18n/I18nContext";

export default function Header({ onBuy }) {
  const { t } = useI18n();

  const scrollTo = (e, href) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const NAV = [
    { label: t.header.inside, href: "#inside", id: "inside" },
    { label: t.header.templates, href: "#templates", id: "templates" },
    { label: t.header.asha, href: "#asha", id: "asha" },
    { label: t.header.faq, href: "#faq", id: "faq" },
    { label: t.header.affiliate, href: "/affiliate", id: "affiliate", route: true },
  ];

  return (
    <motion.header
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.2, 0.8, 0.2, 1], delay: 0.1 }}
      className="fixed top-0 inset-x-0 z-50"
      data-testid="site-header"
    >
      <div className="container-x">
        <div
          className="mt-3 flex items-center justify-between gap-3 rounded-full px-4 py-2.5 md:px-5 md:py-3 bg-[rgba(253,251,247,0.92)] backdrop-blur-xl border border-[rgba(15,31,23,0.08)] shadow-[0_8px_30px_-12px_rgba(15,31,23,0.18)]"
        >
          <a
            href="#top"
            onClick={(e) => scrollTo(e, "#top")}
            className="flex-shrink-0"
            data-testid="header-logo"
          >
            <WordMark />
          </a>

          <nav className="hidden md:flex items-center gap-1">
            {NAV.map((item) => (
              <a
                key={item.id}
                href={item.href}
                onClick={item.route ? undefined : (e) => scrollTo(e, item.href)}
                className={`px-3.5 py-1.5 rounded-full text-sm font-medium transition-colors ${
                  item.route
                    ? "text-[var(--marigold)] hover:bg-[var(--marigold)]/10"
                    : "text-[var(--ink-2)]/70 hover:text-[var(--ink)] hover:bg-[var(--cream-2)]"
                }`}
                data-testid={`nav-${item.id}`}
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <LangToggle variant="light" />
            <button
              onClick={onBuy}
              className="btn-pill btn-primary text-sm py-2 px-4 md:px-5"
              data-testid="header-buy-button"
            >
              <span>{t.header.buy}</span>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                <path
                  d="M5 12h14M13 5l7 7-7 7"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </motion.header>
  );
}
